import React from "react";
import Style from "./Networking.module.scss";

export const NetworkingCard = ({
  number,
  title,
  text,
}: {
  number: string;
  title: string;
  text: string;
}) => (
  <div className={Style.card}>
    <div className={Style.cardheader}>
      <div className={Style.cardnumber}>{number}</div>
      <div className={Style.cardtitle}>{title}</div>
    </div>
    <div className={Style.cardtext}>{text}</div>
  </div>
);
